import styled from 'styled-components';
import { Stack } from '@karma/components';

export const Body = styled(Stack).attrs({
  fullWidth: true,
  direction: 'column',
  spacing: 20,
})``;
